import script from "./PrayerRequestInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PrayerRequestInfo.vue?vue&type=script&setup=true&lang=js"

import "./PrayerRequestInfo.vue?vue&type=style&index=0&id=2dc65394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc65394"]])

export default __exports__